export default __webpack_public_path__ + "2b02f1ad474d89c1c93797326348b57e.png";